import React from "react";

// Project Imports
import WithLayout from "../../../components/WithLayout";
import Admin from "../../../layouts/Admin";
import DashSlugs from "../../../views/Admin/DashboardItems";

// ================= Main Dashboard ================= //
const Dashboard = () => {
  return <WithLayout layout={Admin} component={DashSlugs} />;
};

export default Dashboard;
